import { ChallengeStatusFilter } from "../services/challenge/type"

import { TableDataType } from "./eums"
import { TableColumnsInterface } from "./interfaces"

export const CHALLENGE_COLUMNS: TableColumnsInterface[] = [
  { value: "id", title: "challenges.columns.id", format: TableDataType.SHORTENED_STRING, sorting: false, mntSorting: true },
  { value: "game.title", title: "challenges.columns.game", format: TableDataType.STRING, sorting: false },
  { value: "game.identifier", title: "challenges.columns.gameId", format: TableDataType.STRING, sorting: false, mntSorting: true },
  { value: "game.image", title: "challenges.columns.image", format: TableDataType.IMAGE, sorting: false },
  { value: "description", title: "challenges.columns.description", format: TableDataType.STRING, sorting: false },
  {
    value: "min_bet_amount_usd",
    title: "challenges.columns.minBet",
    format: TableDataType.FIAT_CURRENCY,
    sorting: true
  },
  { value: "required_multiplier", title: "challenges.columns.multiplier", format: TableDataType.NUMBER, sorting: true },
  { value: "prize_amount_usd", title: "challenges.columns.prize", format: TableDataType.FIAT_CURRENCY, sorting: true },
  { value: "is_active", title: "challenges.columns.active", format: TableDataType.BOOLEAN, sorting: true },
  { value: "end_at", title: "challenges.columns.endAt", format: TableDataType.DATE, sorting: true },
  { value: "winner.username", title: "challenges.columns.winner", format: TableDataType.STRING, sorting: false }
]

export const STATUS_FILTER_OPTIONS: { labelKey: string; value: ChallengeStatusFilter }[] = [
  { labelKey: "challenges.filters.all", value: "all" },
  { labelKey: "challenges.filters.live", value: "live" },
  { labelKey: "challenges.filters.inactive", value: "inactive" },
  { labelKey: "challenges.filters.finished", value: "finished" },
  { labelKey: "challenges.filters.won", value: "won" },
  { labelKey: "challenges.filters.expired", value: "expired" }
]

interface InputFieldConfig {
  name: string
  titleKey: string
  placeholderKey: string
  type?: string
  showAltLabel?: boolean
}

export const CHALLENGE_FORM_FIELDS: InputFieldConfig[] = [
  {
    name: "description",
    titleKey: "challenges.form.description",
    placeholderKey: "challenges.form.descriptionPlaceholder"
  },
  {
    name: "min_bet_amount_usd",
    titleKey: "challenges.form.minBet",
    placeholderKey: "challenges.form.minBetPlaceholder",
    type: "number",
    showAltLabel: true
  },
  {
    name: "required_multiplier",
    titleKey: "challenges.form.multiplier",
    placeholderKey: "challenges.form.multiplierPlaceholder",
    type: "number"
  },
  {
    name: "prize_amount_usd",
    titleKey: "challenges.form.prize",
    placeholderKey: "challenges.form.prizePlaceholder",
    type: "number",
    showAltLabel: true
  }
]

export const STATUS_FILTER_DESCRIPTION_KEYS = [
  { key: "all", labelKey: "challenges.filters.all", descriptionKey: "challenges.overview.statusFilters.all" },
  { key: "live", labelKey: "challenges.filters.live", descriptionKey: "challenges.overview.statusFilters.live" },
  {
    key: "finished",
    labelKey: "challenges.filters.finished",
    descriptionKey: "challenges.overview.statusFilters.finished"
  },
  { key: "won", labelKey: "challenges.filters.won", descriptionKey: "challenges.overview.statusFilters.won" },
  {
    key: "expired",
    labelKey: "challenges.filters.expired",
    descriptionKey: "challenges.overview.statusFilters.expired"
  },
  {
    key: "inactive",
    labelKey: "challenges.filters.inactive",
    descriptionKey: "challenges.overview.statusFilters.inactive"
  }
]

export const COLUMN_DESCRIPTION_KEYS = [
  { key: "id", labelKey: "challenges.columns.id", descriptionKey: "challenges.overview.columnDescriptions.id" },
  { key: "game", labelKey: "challenges.columns.game", descriptionKey: "challenges.overview.columnDescriptions.game" },
  {
    key: "gameId",
    labelKey: "challenges.columns.gameId",
    descriptionKey: "challenges.overview.columnDescriptions.gameId"
  },
  {
    key: "image",
    labelKey: "challenges.columns.image",
    descriptionKey: "challenges.overview.columnDescriptions.image"
  },
  {
    key: "description",
    labelKey: "challenges.columns.description",
    descriptionKey: "challenges.overview.columnDescriptions.description"
  },
  {
    key: "minBet",
    labelKey: "challenges.columns.minBet",
    descriptionKey: "challenges.overview.columnDescriptions.minBet"
  },
  {
    key: "multiplier",
    labelKey: "challenges.columns.multiplier",
    descriptionKey: "challenges.overview.columnDescriptions.multiplier"
  },
  {
    key: "prize",
    labelKey: "challenges.columns.prize",
    descriptionKey: "challenges.overview.columnDescriptions.prize"
  },
  {
    key: "active",
    labelKey: "challenges.columns.active",
    descriptionKey: "challenges.overview.columnDescriptions.active"
  },
  {
    key: "endAt",
    labelKey: "challenges.columns.endAt",
    descriptionKey: "challenges.overview.columnDescriptions.endAt"
  },
  {
    key: "winner",
    labelKey: "challenges.columns.winner",
    descriptionKey: "challenges.overview.columnDescriptions.winner"
  }
]
